import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { orange } from '@mui/material/colors';
import { CreditCard } from 'react-feather';
import { formatNumber } from '../../utils';

function TotalCredits(props) {
  const userState = useSelector((state) => state.userReducer);
  const { counts } = userState;

  return (
    <Card {...props}>
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between' }}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              TOTAL LOANS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {formatNumber(counts.creditCount)}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: orange[600],
                height: 56,
                width: 56,
              }}
            >
              <CreditCard />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default TotalCredits;
